/**
 * Checks if a full URL points to the current application
 */
export const isUrlFromCurrentDomain = (url: string): boolean => {
  try {
    // Only process URLs with protocol
    if (url.includes("://")) {
      return new URL(url).hostname === window.location.hostname;
    }
    return false;
  } catch {
    return false;
  }
};

/**
 * Extracts path from a full URL
 */
export const getPathFromUrl = (url: string): string => {
  try {
    return new URL(url).pathname;
  } catch {
    return "";
  }
};

/**
 * Strips a trailing slash from a path (except the root path itself), so
 * "/events/" and "/events" are treated as the same route.
 */
export const normalizePath = (path: string): string =>
  path.replace(/\/+$/, "") || "/";

/**
 * Determines if a path matches the current location.
 *
 * `urlPath` is normalised to strip any trailing slash first.
 */
export const isPathActive = (pathname: string, urlPath: string): boolean => {
  const normalizedUrlPath = normalizePath(urlPath);
  return (
    pathname === normalizedUrlPath ||
    (normalizedUrlPath !== "/" && pathname.startsWith(`${normalizedUrlPath}/`))
  );
};
